import {
  APP_FONT_SIZE_MEDIUM,
  APP_FONT_SIZE_EXTRA_SMALL,
  APP_FONT_SIZE_SMALL,
  APP_FONT_SIZE_LARGE,
  APP_FONT_SIZE_EXTRA_LARGE,
} from './font-constants';

export const seedDefaultFont = 'Lato';
export const seedSupportedFonts = ['Lato', 'Roboto'];

export const seedDefaultFontSize = APP_FONT_SIZE_MEDIUM;
export const seedSupportedFontSizes = [
  APP_FONT_SIZE_EXTRA_SMALL,
  APP_FONT_SIZE_SMALL,
  APP_FONT_SIZE_MEDIUM,
  APP_FONT_SIZE_LARGE,
  APP_FONT_SIZE_EXTRA_LARGE,
];
